import React from "react";
import withStyles from '@mui/styles/withStyles';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

import Button from '@mui/material/Button';

const styles = {
    dialogContent: {
        display: 'flex',
        flexDirection: 'column'
    }
};

const DeleteMontantMiniRetourExcluDialog = ({ classes, onClose, onClickDelete, montantMiniRetourExclu, niveaux, open }) => {

    let niveau = niveaux.find(n => n.id === montantMiniRetourExclu.niveau);

    /** Suppression d'un montant mini */
    const deleteMontantMini = () => {
        onClickDelete(montantMiniRetourExclu, niveau);
        onClose();
    }

    return (
        <Dialog open={open}>
            <DialogTitle>Suppression d'une exclusion pour les montants mini au retour</DialogTitle>

            <DialogContent className={classes.dialogContent}>

                <p>Êtes-vous sûr de vouloir supprimer l'exclusion pour le niveau <strong>{niveau.libelle}</strong> avec le code <strong>{montantMiniRetourExclu.code}</strong> ?</p>

            </DialogContent>

            <DialogActions>
                <Button
                    onClick={onClose}
                    color="primary"
                >
                    Annuler
                </Button>
                <Button
                    onClick={deleteMontantMini}
                    variant="contained"
                    color="secondary"
                >
                    Supprimer
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default withStyles(styles)(DeleteMontantMiniRetourExcluDialog);
